module.exports = __webpack_public_path__ + "img/u2835.00470aae.png";